import React from 'react'
// External dependencies
import classNames from 'classnames'
interface WrapperCardHeaderProps {
  className?: string; // Optional className for the header
  children?: React.ReactNode; // To allow any React children
}

const WrapperCardHeader: React.FC<WrapperCardHeaderProps> = ({
  className,
  ...props
}) => {
 // Combining default and additional classes for the Header classess
    const HeaderClasses = classNames("m-portlet__head  m-portlet__head__sm", className);
  return (
    <div className={HeaderClasses}>
      {props.children}
    </div>
  )
}

export default WrapperCardHeader
